import React from "react";
import PropTypes from "prop-types";
import { DefaultButton } from "office-ui-fabric-react/lib/Button";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";

export const buttonStyles = {
  danger: {
    root: { backgroundColor: "#dc3545", color: "white" },
    rootHovered: { backgroundColor: "#bd2130", color: "white" },
  },
  dangerLight: {
    root: { backgroundColor: "#FFCCCB" },
    rootHovered: { backgroundColor: "red", color: "white" },
  },
  warning: {
    root: { backgroundColor: "#ffc107", color: "black" },
    rootHovered: { backgroundColor: "#d39e00", color: "black" },
  },
  warningLight: {
    root: { backgroundColor: "#ffd1b7", color: "black" },
    rootHovered: { backgroundColor: "#ffc107", color: "black" },
  },
  blue: {
    root: { backgroundColor: "#0062cc", color: "black" },
    rootHovered: { backgroundColor: "#0056b3", color: "white" },
  },
  blueLight: {
    root: { backgroundColor: "#add8e6", color: "black" },
    rootHovered: { backgroundColor: "#0062cc", color: "white" },
  },
  greenLight: {
    root: { backgroundColor: "#3ded97", color: "black" },
    rootHovered: { backgroundColor: "#234f1e", color: "white" },
  },
};

/**
  ***example description** Desciption of the Danger Button...
  [link](http://www.google.com)
*/
export const DangerButtonWithoutMemo = (props) => (
  <DefaultButton styles={buttonStyles.danger} {...props} />
);
DangerButtonWithoutMemo.propTypes = {
  /**
    ***example description** - To get the entire list of props, visit:
    [React UI Fabric](https://developer.microsoft.com/en-us/fluentui#/controls/web/button)
  */
  text: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.bool.isRequired,
  ]).isRequired,
};

export const DangerButton = React.memo(DangerButtonWithoutMemo);

export const DangerLightButton = React.memo((props) => (
  <DefaultButton styles={buttonStyles.dangerLight} {...props} />
));
export const WarningButton = React.memo((props) => (
  <DefaultButton styles={buttonStyles.warning} {...props} />
));
export const WarningLightButton = React.memo((props) => (
  <DefaultButton styles={buttonStyles.warningLight} {...props} />
));
export const BlueButton = React.memo((props) => (
  <DefaultButton styles={buttonStyles.blue} {...props} />
));
export const BlueLightButton = React.memo((props) => (
  <DefaultButton styles={buttonStyles.blueLight} {...props} />
));
export const GreenLightButton = React.memo((props) => (
  <DefaultButton styles={buttonStyles.greenLight} {...props} />
));

export const DeleteButton = (
  <DefaultButton
    styles={buttonStyles.dangerLight}
    iconProps={{ iconName: "Delete" }}
  >
    Delete
  </DefaultButton>
);
export const EditButton = (
  <DefaultButton iconProps={{ iconName: "Edit" }}>Edit</DefaultButton>
);

export const SubmitButton = React.memo((props) => (
  <DefaultButton primary {...props} disabled={props.spin || props.disabled}>
    {props.spin && <Spinner size={SpinnerSize.small} />}
  </DefaultButton>
));
